import { GET_AUXILIARY_CLASSIFICATION_DATA, SET_AUXILIARY_CLASSIFICATION_ID, GET_AUXILIARY_MASTER_BY_ACCOUNT_DATA, RESET_AUXILIARY_MASTER_BY_ACCOUNT_DATA, GET_ACCOUNT_AUXILIARY_RESUME_DATA,
        RESET_ACCOUNT_AUXILIARY_DATA,RESET_AUXILIARY_ACCOUNT_RESUME_DATA, GET_AUXILIARY_ACCOUNT_RESUME_DATA} from '../../../../constants/ActionTypes'
import { AxiosEXCELReport, AxiosPDFReport, getRequest, postRequest, putRequest } from '../../Axios'

export const GetAuxiliaryClassificationData = (params) => (dispatch) => {
    dispatch(getRequest("/AuxiliaryClassification", params))
        .then(resp => {
            dispatch({
                type: GET_AUXILIARY_CLASSIFICATION_DATA,
                payload: resp.payload.data
            })
        })
        .catch(error => {
            console.log(error)
        })
}

export const addAuxiliar = (params, body, callBack) => (dispatch) => {
    dispatch(postRequest('/AuxiliaryMaster/', params, body))
        .then(resp => {
            const { payload: { data, status } } = resp
            callBack(data, status);
        })
        .catch(error => {
            console.log(error)
        })
}

export const updateAuxiliar = ({ id }, body, callBack) => (dispatch) => {
    dispatch(putRequest(`/AuxiliaryMaster/${id}`, { id }, body))
        .then(resp => {
            const { payload: { data, status } } = resp
            callBack(data, status);
        })
        .catch(error => {
            console.log(error)
        })
}

export const UpdateAuxiliaryMasterStatus = (AuxiliaryMaster) => async (dispatch) => {
    return await dispatch(putRequest(`/AuxiliaryMaster/UpdateAuxiliaryMasterStatus`, { Id: AuxiliaryMaster.auxiliaryId }, AuxiliaryMaster))
        .then(({ payload: { data, status } }) => ({ data, status }))
        .catch(() => null);
}

export const setAuxiliaryClassificationID = (id) => (

    {
        type: SET_AUXILIARY_CLASSIFICATION_ID,
        payload: id
    }
)

export const GetAccountByAuxiliaryResumeData = (params) => (dispatch) => {
    dispatch(getRequest("/AuxiliaryMaster/GetAccountByAuxiliaryResumeData", params))
        .then(resp => {
            dispatch({
                type: GET_ACCOUNT_AUXILIARY_RESUME_DATA,
                payload: resp.payload.data
            })
        })
        .catch(error => {
            console.log(error)
        })
}

export const ResetAccountAuxiliary = () => (
    {
        type: RESET_ACCOUNT_AUXILIARY_DATA
    }
)
export const GetAuxiliaryMasterByAccountData = (params) => (dispatch) => {
    dispatch(getRequest("/AuxiliaryMaster/GetAuxiliaryByAccountData", params))
        .then(resp => {
            dispatch({
                type: GET_AUXILIARY_MASTER_BY_ACCOUNT_DATA,
                payload: resp.payload.data
            })
        })
        .catch(error => {
            console.log(error)
        })
}

export const ResetAuxiliaryMasterByAccount = () => (
    {
        type: RESET_AUXILIARY_MASTER_BY_ACCOUNT_DATA
    }
)
export const GetAuxiliaryByAccountResumeData = (params) => (dispatch) => {
    dispatch(getRequest("/AuxiliaryMaster/GetAuxiliaryByAccountResumeData", params))
        .then(resp => {
            dispatch({
                type: GET_AUXILIARY_ACCOUNT_RESUME_DATA,
                payload: resp.payload.data
            })
        })
        .catch(error => {
            console.log(error)
        })
}

export const ResetAuxiliaryAccountResume = () => (
    {
        type: RESET_AUXILIARY_ACCOUNT_RESUME_DATA
    }
)

export const ExcelAuxiliaryMovementReport = (params, dispatch) => {
    AxiosEXCELReport("AuxiliaryMaster/ExcelAuxiliaryMovementReport", params, "Movimiento Por Cuenta Auxiliares", dispatch)
}

export const PdfAuxiliaryMovementReport = (params, dispatch) => {
    AxiosPDFReport("AuxiliaryMaster/PdfAuxiliaryMovementReport", params, dispatch);
}



export const ExcelAuxiliaryByAccountReport = (params, dispatch) => {
    AxiosEXCELReport("AuxiliaryMaster/ExcelAuxiliaryByAccountReport", params, "Resumen Auxiliar Por Cuenta", dispatch)
}

export const PdfAuxiliaryByAccountReport = (params, dispatch) => {
    AxiosPDFReport("AuxiliaryMaster/PdfAuxiliaryByAccountReport", params, dispatch);
}


export const ExcelAccountByAuxiliaryReport = (params, dispatch) => {
    AxiosEXCELReport("AuxiliaryMaster/ExcelAccountByAuxiliaryReport", params, "Resumen Cuenta Por Auxiliar", dispatch)
}

export const PdfAccountByAuxiliaryReport = (params, dispatch) => {
    AxiosPDFReport("AuxiliaryMaster/PdfAccountByAuxiliaryReport", params, dispatch);
}
export const ExcelAuxiliaryMovementReportReport = (params, dispatch) => {
    AxiosEXCELReport("AuxiliaryMaster/ExcelAuxiliaryMovementReportReport", params, "Resumen Cuenta Por Auxiliar", dispatch)
}

export const PdfAuxiliaryMovementReportReport    = (params, dispatch) => {
    AxiosPDFReport("AuxiliaryMaster/PdfAuxiliaryMovementReportReport", params, dispatch);
}